import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f08a5e8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    style: {"position":"relative","cursor":"default","z-index":"1"},
    onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseOverHandler && _ctx.mouseOverHandler(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveHandler && _ctx.mouseLeaveHandler(...args)))
  }, [
    (_ctx.showTooltip)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "tooltip-container",
          style: _ctx.tooltipStyles,
          ref: "tooltipContainer"
        }, _toDisplayString(_ctx.tooltipMessage), 5))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 32))
})